(function() {
  'use strict';

  angular
    .module('CRMClient', ['ngAnimate', 'ngSanitize', 'ngMessages', 'ui.router', 'ui.bootstrap', 'toastr', 'ui.select', 'angular-loading-bar', 'ng-locale-number', 'file-model', 'angular-jwt', 'angular-storage']);

})();

(function () {
  'use strict';

  angular
    .module('CRMClient')
    .controller('MainContactListController', MainContactListController);

  /** @ngInject */
  function MainContactListController($log, _, $uibModal, toastr, CONTACTHandling, Papa, saveAs, $scope) {

    var vm = this;
    vm.contactList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.inProcess = false;

    vm.check = {
      item: [],
      mainItem: false,
      checkAll: function () {
        _.each(vm.contactList, function (o, n) {
          vm.check.item[n].status = vm.check.mainItem;
        });

        $log.info(vm.check.item);

      }
    };

    vm.filter = {
      page: 1,
      per_page: 10,
      search: null,
      by_hp: null,
      by_status: 1,
      by_cust_code: null
    };

    vm.editContact = function (contact) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/components/modals/EditContact/EditContactDialog.html',
        controller: 'EditContactDialogController as vm',
        resolve: {
          data: function () {
            return contact;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.deleteContact = function (contact) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/DeleteContact/DeleteContactDialog.html',
        controller: 'DeleteContactDialogController as vm',
        resolve: {
          data: function () {
            return contact;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.importContact = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/ImportContact/ImportContactDialog.html',
        controller: 'ImportContactController as vm'
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.deleteSelectedContacts = function () {

      var list_id = _(vm.check.item).filter(function (n) { return n.status === true; }).map(function (n) { return n.id; }).value();

      $log.info('Jalan');
      $log.debug(list_id);

      if (!_.isEmpty(list_id)) {
        CONTACTHandling.delete(list_id).then(function () {
          vm.initView(vm.filter.page);
          toastr.success('Berhasil hapus data kontak', 'Hapus berhasil');
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal hapus kontak. Kode error: ' + error.status, 'Gagal hapus');
        });
      }

    };

    function getData(page, filter, currentData, callback) {

      filter.per_page = 100;
      var contactList = currentData;

      filter.page = page;

      CONTACTHandling.list(filter).then(function (response) {

        contactList = contactList.concat(response.data.data);

        if (response.data.data.length === filter.per_page) {
          getData(page + 1, filter, contactList, callback);
        } else {
          callback(contactList);
        }
      }, function (error) {
        $log.error(error);
        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;
        toastr.error('Terjadi kesalahan saat download riwayat transaksi', 'Gagal');
      });
    }

    vm.downloadContact = function () {
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      getData(1, filter, [], function (data) {

        $scope.main.message = 'Konversi ke csv';

        var csv = Papa.unparse(data, {
          worker: false,
          skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var filename = 'contact_';

        saveAs(blob, filename + "_.csv");

      });
    };

    vm.printContact = function (contact) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/PrintContact/PrintContactDialog.html',
        controller: 'PrintContactDialogController as vm',
        resolve: {
          data: function () {
            return contact;
          }
        }
      }).result.then(function () {
        $log.info('Ok');
      });
    };

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      vm.check.mainItem = false;

      CONTACTHandling.list(filter).then(function (response) {
        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.contactList = response.data.data;

        _.each(vm.contactList, function (o, n) {
          vm.check.item[n] = {
            status: false,
            id: o.id
          };
        });
      }, function (error) {
        $log.error(error);
        if (error.status === 408) {
          toastr.error(error.data.message, 'Terjadi Kesalahan');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data kontak', 'Terjadi Kesalahan');
        }
      });
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('MainAdministrasiUsersController', MainAdministrasiUsersController);

  /** @ngInject */
  function MainAdministrasiUsersController(APIHandling, $log, $uibModal, $filter) {

    var vm = this;
    vm.userList;
    vm.currentUser = APIHandling.getCurrentUser();

    vm.initView = function () {
      APIHandling.get('user/list').then(function (response) {
        vm.userList = $filter('fm-detail') (response.data.data);
      });
    };

    vm.userModal = function (user) {

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/EditUser/EditUserDialog.html',
        controller: 'EditUserDialogController as vm',
        resolve: {
          data: function () {
            return user;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.initView();
      });
    };

    vm.deleteUser = function (user) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/DeleteUser/DeleteUserDialog.html',
        controller: 'DeleteUserDialogController as vm',
        resolve: {
          data: function () {
            return user;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.initView();
      });
    };

    vm.initView();

  }
})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('MainAdministrasiSMSController', MainAdministrasiSMSController);

  /** @ngInject */
  function MainAdministrasiSMSController(APIHandling, $log, $uibModal) {

    var vm = this;
    vm.templateList;

    vm.initView = function () {
      APIHandling.get('sms-template/list').then(function (response) {
        vm.templateList = response.data.data;
      });
    };

    vm.editTemplate = function (template) {

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/EditSMS/EditSMSDialog.html',
        controller: 'EditSMSDialogController as vm',
        resolve: {
          data: function () {
            return template;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.initView();
      });
    };

    vm.deleteTemplate = function (template) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/DeleteTemplate/DeleteTemplateDialog.html',
        controller: 'DeleteTemplateDialogController as vm',
        resolve: {
          data: function () {
            return template;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.initView();
      });
    };

    vm.initView();

  }
})();

(function () {
  'use strict';

  angular
    .module('CRMClient')
    .factory('LOGHandling', LOGHandling);

    function LOGHandling($log, ngDexie, moment) {
      var instance = this;

      instance.log = function (data) {
        $log.log(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'log', log: data});
      };

      instance.debug = function (data) {
        $log.debug(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'debug', log: data}).then(function () {
          $log.info('Simpan log ' + data.comment);
        }, function (error) {
          $log.warn({msg: 'Gagal menyimpan log ' + data.comment, err: error});
        });
      };

      instance.info = function (data) {
        $log.info(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'info', log: data});
      };

      instance.warn = function (data) {
        $log.warn(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'warn', log: data});
      };

      instance.error = function (data) {
        $log.log(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'error', log: data});
      };

      instance.getLog = function (option, callback) {
        $log.log(option);
        ngDexie.list('logs').then(function (data) {
          callback (data);
        });
      };

      return instance;

    }

})();

(function () {
  'use strict';

  angular
    .module('CRMClient')
    .factory('LOCATIONHandling', LOCATIONHandling);

    function LOCATIONHandling(APIHandling) {
      var instance = this;

      instance.provinsiRO = [
                              {
                                  "id": "1",
                                  "text": "Bali",
                                  "kode": "BA"
                              },
                              {
                                  "id": "2",
                                  "text": "Bangka Belitung",
                                  "kode": "BB"
                              },
                              {
                                  "id": "3",
                                  "text": "Banten",
                                  "kode": "BT"
                              },
                              {
                                  "id": "4",
                                  "text": "Bengkulu",
                                  "kode": "BE"
                              },
                              {
                                  "id": "5",
                                  "text": "DI Yogyakarta",
                                  "kode": "YO"
                              },
                              {
                                  "id": "6",
                                  "text": "DKI Jakarta",
                                  "kode": "JK"
                              },
                              {
                                  "id": "7",
                                  "text": "Gorontalo",
                                  "kode": "GO"
                              },
                              {
                                  "id": "8",
                                  "text": "Jambi",
                                  "kode": "JA"
                              },
                              {
                                  "id": "9",
                                  "text": "Jawa Barat",
                                  "kode": "JB"
                              },
                              {
                                  "id": "10",
                                  "text": "Jawa Tengah",
                                  "kode": "JT"
                              },
                              {
                                  "id": "11",
                                  "text": "Jawa Timur",
                                  "kode": "JI"
                              },
                              {
                                  "id": "12",
                                  "text": "Kalimantan Barat",
                                  "kode": "KB"
                              },
                              {
                                  "id": "13",
                                  "text": "Kalimantan Selatan",
                                  "kode": "KS"
                              },
                              {
                                  "id": "14",
                                  "text": "Kalimantan Tengah",
                                  "kode": "KT"
                              },
                              {
                                  "id": "15",
                                  "text": "Kalimantan Timur",
                                  "kode": "KI"
                              },
                              {
                                  "id": "16",
                                  "text": "Kalimantan Utara",
                                  "kode": "KU"
                              },
                              {
                                  "id": "17",
                                  "text": "Kepulauan Riau",
                                  "kode": "KR"
                              },
                              {
                                  "id": "18",
                                  "text": "Lampung",
                                  "kode": "LA"
                              },
                              {
                                  "id": "19",
                                  "text": "Maluku",
                                  "kode": "MA"
                              },
                              {
                                  "id": "20",
                                  "text": "Maluku Utara",
                                  "kode": "MU"
                              },
                              {
                                  "id": "21",
                                  "text": "Nanggroe Aceh Darussalam (NAD)",
                                  "kode": "AC"
                              },
                              {
                                  "id": "22",
                                  "text": "Nusa Tenggara Barat (NTB)",
                                  "kode": "NB"
                              },
                              {
                                  "id": "23",
                                  "text": "Nusa Tenggara Timur (NTT)",
                                  "kode": "NT"
                              },
                              {
                                  "id": "24",
                                  "text": "Papua",
                                  "kode": "PA"
                              },
                              {
                                  "id": "25",
                                  "text": "Papua Barat",
                                  "kode": "PB"
                              },
                              {
                                  "id": "26",
                                  "text": "Riau",
                                  "kode": "RI"
                              },
                              {
                                  "id": "27",
                                  "text": "Sulawesi Barat",
                                  "kode": "SR"
                              },
                              {
                                  "id": "28",
                                  "text": "Sulawesi Selatan",
                                  "kode": "SN"
                              },
                              {
                                  "id": "29",
                                  "text": "Sulawesi Tengah",
                                  "kode": "ST"
                              },
                              {
                                  "id": "30",
                                  "text": "Sulawesi Tenggara",
                                  "kode": "SG"
                              },
                              {
                                  "id": "31",
                                  "text": "Sulawesi Utara",
                                  "kode": "SA"
                              },
                              {
                                  "id": "32",
                                  "text": "Sumatera Barat",
                                  "kode": "SB"
                              },
                              {
                                  "id": "33",
                                  "text": "Sumatera Selatan",
                                  "kode": "SS"
                              },
                              {
                                  "id": "34",
                                  "text": "Sumatera Utara",
                                  "kode": "SU"
                              }
                            ];

      instance.getKabupaten = function (prov_id) {
        return APIHandling.get('raja-ongkir/get-kab', {prov_id: prov_id});
      };

      instance.getKecamatan = function (kab_id) {
        return APIHandling.get('raja-ongkir/get-kec', {kab_id: kab_id});
      };

      return instance;

    }

})();

(function () {
  'use strict';

  angular
    .module('CRMClient')
    .factory('CONTACTHandling', CONTACTHandling);

    function CONTACTHandling(APIHandling) {
      var instance = this;

      this.get = function (cust_id) {
        return APIHandling.get('kontak/get', {id: cust_id});
      };

      this.list = function (params) {
        return APIHandling.get('kontak/list', params);
      };

      this.save = function (data) {
        return APIHandling.post('kontak/save', data);
      };

      this.delete = function (list_id) {
        return APIHandling.post('kontak/delete', {list_id: list_id});
      };


      this.import = function (data) {
        return APIHandling.post('kontak/import-gcontact', {data: data});
      };

      return instance;

    }

})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .factory('AuthInterceptor', AuthInterceptor);

  /** @ngInject */
  function AuthInterceptor($q, $injector) {
    return {
        'responseError': function (rejection) {

            var invalidToken = false;

            if (rejection.status === 400) {
              invalidToken = true;
            }

            if (invalidToken || rejection.status === 401) {
                $injector.get('$state').go('login');
            }

            return $q.reject(rejection);
        }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('CRMClient')
    .factory('APIHandling', APIHandling);

  function APIHandling($http, store, $q, $timeout, BASEURL, TIMEOUT) {
    var instance = this;

    /* Batas timeout http request, dalam ms */
    this.timeOutLimit = TIMEOUT;

    /* baseURL API Call */
    this.baseURL = BASEURL;

    this.httpRequest = function (method, endpoint, data, params) {

      /* Set timeout dan result sebagai promise */
      var timeout = $q.defer();
      var result = $q.defer();

      /* Set status timeout */
      var isTimeOut = false;

      /* Set timeout untuk resolve dalam jangka waktu yang ditentukan, yaitu timeOutLimit */
      $timeout(function () {
          /* Set status timeout menjadi true jika promise timeout resolved */
          isTimeOut = true;
          timeout.resolve();
      }, (instance.timeOutLimit));

      /* Lakukan http request, set timeout terjadi ketika promise timeout resolved, yaitu pada saat timeOutLimit */
      // var req = $http.get( instance.baseURL + endpoint, { params: data, timeout: timeout.promise, paramSerializer: '$httpParamSerializerJQLike' });

      var req = $http({
          method: method,
          url: instance.baseURL + endpoint,
          data: data,
          params: params,
          paramSerializer: '$httpParamSerializerJQLike',
          timeout: instance.timeOutLimit,
          headers: {
              'Accept': 'application/json;charset=utf-8',
              'Content-Type': 'application/json;charset=utf-8'
          }
      });

      req.then(function (response) {
        return result.resolve(response);
      }, function (error) {
        /*
          Jika status timeout === true, maka request belum dapat balasan saat timeout resolved, berarti request belum dapat response melebihi
          waktu timeout yang kita sediakan. Maka set response error dengan status 408 Request Timeout
        */
        if (isTimeOut) {
          result.reject({
            status: 408,
            statusText: 'Request Timeout',
            data: {
              message: 'Proses lebih lama dari ' + (instance.timeOutLimit / 1000) + ' detik dan belum mendapat balasan. Batalkan'
            }
          });
        } else {
            result.reject(error);
        }
      });

      return result.promise;
    };

    this.get = function (endpoint, params) {
      // return $http.get( instance.baseURL + endpoint, { params: data, timeout: instance.timeOutLimit, paramSerializer: '$httpParamSerializerJQLike' });
      return instance.httpRequest('GET', endpoint, null, params);
    };

    this.post = function (endpoint, data) {
      // return $http.post( instance.baseURL + endpoint, data, { timeout: (instance.timeOutLimit) });
      return instance.httpRequest('POST', endpoint, data);
    };

    this.login = function (username, password) {
      return $http(
            {
                method: 'POST',
                url: instance.baseURL + 'user/login',
                data: {uname : username, password: password},
                timeout: instance.timeOutLimit,
                skipAuthorization: true,
                headers: {
                    'Accept': 'application/json;charset=utf-8',
                    'Content-Type': 'application/json;charset=utf-8'
                }
            }
        );
    };

    this.getLiveStock = function (data) {
      return $http.get( instance.baseURL + 'daftar-produk', { params: data, timeout: instance.timeOutLimit, skipAuthorization: true, paramSerializer: '$httpParamSerializerJQLike' });
    };

    this.cleanLoginState = function () {
      store.remove('token');
      store.remove('info');
    };

    this.saveLoginState = function (loginData) {
      store.set('token', loginData.data.token);
      store.set('info', loginData.data.user);
    };

    this.getCurrentUser = function () {
      return store.get('info');
    };

    this.getInfoServer = function () {
      return $http.get(instance.baseURL + 'info');
    };

    return this;

  }
})();

(function () {
  'use strict';

  angular
    .module('CRMClient')
    .factory('ADDRESSHandling', ADDRESSHandling);

    function ADDRESSHandling(pdfMake, _, $filter, $log) {
      var instance = this;

      instance.print = function (data, dataSender) {

        $log.info(dataSender);
        var alamat;

        if (dataSender.isDropship === true) {
          alamat = [
                  { text: 'Pengirim:', style: 'sender', bold: true},
                  { text: dataSender.sender.nama, style: 'sender'},
                  { text: dataSender.sender.alamat ? (dataSender.sender.alamat + ' ' + dataSender.sender.kec + ' ' +  dataSender.sender.kab + ' ' + dataSender.sender.prov + ' ' + (dataSender.sender.kode_pos || '')) : (dataSender.sender.alamat_sender || ''), style: 'sender'}
                ];
        } else {
          alamat = [
                  { text: 'Pengirim:', style: 'sender', bold: true},
                  { text: dataSender.sender.nama, style: 'sender'},
                  { text: dataSender.sender.hp, style: 'sender'}
                ];
        }

        var docDefinition = {
          pageSize: {width: 297.64, height: 595.28},   /** Lebar == lebar A6, tinggi == lebar A4 */
          pageOrientation: 'landscape',
          pageMargins: [ 20, 20, 20, 20 ],

          content: [
            { text: data.nama, style: 'name'},
            // {text: '   ', style: 'sender'},
            { text: (data.alamat || '') + ' ' + (data.kec || ''), style: 'address'},
            { text: (data.kab || '') + ' ' + (data.prov || '')  + ' ' + (data.kode_pos || ''), style: 'address'},
            { text: (data.hp || ''), style: 'phone' },
            {text: '   ', style: 'sender'},
            {
              columns: [
                [
                  { text: 'Ekspedisi:', style: 'expedition', bold: true},
                  {columns: [
                    [
                      { text: '[   ]  JNE', style: 'expedition'},
                      { text: '[   ]  JNT', style: 'expedition'}
                    ],
                    [
                      { text: '[   ]  POS', style: 'expedition'},
                      { text: '[   ]  ..................................', style: 'expedition'}
                    ]
                  ]}


                ],
                alamat
              ]
            }

          ],
          defaultStyle: {
            font: 'CrimsonText',
            fontSize: 10
          },
          styles: {
           name: {
             fontSize: 32,
             bold: true
           },
           address: {
             fontSize: 18
           },
           phone: {
             fontSize: 18
           },
           expedition: {
             fontSize: 12
           },
           sender: {
             fontSize: 12,
             alignment: 'left'
           }
         }
        };

        pdfMake.fonts = {
          CourierPrime: {
            normal: 'CourierPrime.ttf',
            bold: 'CourierPrimeBold.ttf',
            italics: 'CourierPrimeItalic.ttf',
            bolditalics: 'CourierPrimeBoldItalic.ttf'
          },
          CrimsonText: {
            normal: 'CrimsonText-Roman.ttf',
            bold: 'CrimsonText-Bold.ttf',
            italics: 'CrimsonText-Italic.ttf',
            bolditalics: 'CrimsonText-BoldItalic.ttf'
          }
        };

        $log.warn(docDefinition);

        pdfMake.createPdf(docDefinition).print();
      };

      return this;

    }

})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('PrintContactDialogController', PrintContactDialogController);

  /** @ngInject */
  function PrintContactDialogController($uibModalInstance, _, $log, toastr, ADDRESSHandling, CONTACTHandling, data) {
      var vm = this;
      vm.contact = data;

      vm.option = {
        sender: 'ethica',
        dropship: {
          isDropship: true,
          sender: {}
        }
      };

      vm.getContact = function (search) {
        CONTACTHandling.list({search: search, per_page: 3}).then(function (response) {

          vm.contactList = response.data.data;
          vm.contactList.push({ id: 0, nama: search, info: 'Dropshipper baru', minfo: 'Sebagai Dropshipper tanpa masuk ke CRM', style: 'noadd' });

        }, function (error) {
          $log.error(error);
          if (error.status === 408) {
            toastr.error(error.data.message, 'Terjadi Kesalahan');
          } else {
            toastr.error('Terjadi kesalahan saat mengambil data kontak', 'Terjadi Kesalahan');
          }
        });
      };

      vm.finish = function () {

        var dataSender = {};

        switch (vm.option.sender) {
          case 'ethica':
            dataSender = {
              isDropship: false,
              sender: {
                nama: 'Ethica Collection',
                hp: '+62 852-306-59936'
              }
            };
            break;
          case 'zafrada':
            dataSender = {
              isDropship: false,
              sender: {
                nama: 'Zafrada',
                hp: '+62 823-4130-7466'
              }
            };
            break;
          case 'dropship':
            dataSender = vm.option.dropship;
            break;
        }

        ADDRESSHandling.print(vm.contact, dataSender);
        $uibModalInstance.close('Ok');
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('ImportContactController', ImportContactController);

  /** @ngInject */
  function ImportContactController($uibModalInstance, $log, CONTACTHandling, toastr, Papa) {
    var vm = this;
    vm.inProcess = false;

    vm.finish = function () {
        $uibModalInstance.close('Ok');
    };

    vm.batal = function () {
        $uibModalInstance.dismiss('batal');
    };


    var uploadData = function (data) {
      $log.info(angular.toJson(data));
      CONTACTHandling.import(data).then(function () {
        toastr.success('Berhasil menyimpan data kontak yang diimport', 'Simpan data berhasil');
        $uibModalInstance.close('Ok');
      }, function (error) {
        var msg;

        if ( error.status === 422 ) {

          msg = 'Format csv yang diimport tidak valid : ';
          for (var e in error.data) {
              msg = msg + '<br /> * ' + error.data[e];
          }

        } else if ( error.status === 400 ) {

          msg = 'Data csv yang diimport tidak valid : <br />' + error.data[0] ;

        } else {
          $log.error( error );
          msg = 'Import kontak gagal karena adanya kesalahan';
        }

        toastr.error(msg, 'Gagal Simpan Data', {
          closeButton: true,
          timeOut: 0
        });

      }).finally(function () {
          vm.inProcess = false;
          angular.element('.loading-animation').hide();
      });
    };

    vm.importTheFile = function () {

      if (!vm.inputFile) {
        toastr.error('Harap pilih terlebih dahulu file yang akan diimport', 'Import file gagal');
      }

      if (vm.inputFile) {

        vm.inProcess = true;
        angular.element('.loading-animation').show();

          Papa.parse(vm.inputFile, {
            header: true,
            skipEmptyLines : true,
            complete: function(results) {
              uploadData(results.data);
            }
        });
      }
    };

  }

})();

 (function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('EditUserDialogController', EditUserDialogController);

  /** @ngInject */
  function EditUserDialogController($uibModalInstance,  _, $log, toastr, APIHandling, data) {
      var vm = this;
      vm.user = {};

      if (_.isUndefined(data)) {
        vm.user = {
          uname: null,
          password: null,
          confirm_password: null,
          detail: {
            name: null
          },
          new: 1
        };
      } else {
        vm.user.uname = data.uname;
        vm.user.detail = {
          name: data.detail ? data.detail.name : null
        };
        vm.user.group = data.group;
        vm.new = 0;
      }

      vm.finish = function () {

        APIHandling.post('user/save', vm.user).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil simpan data pengguna', 'Berhasil simpan');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal simpan data pengguna', 'Gagal simpan');
        }).finally( function () {
          $uibModalInstance.close('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('EditSMSDialogController', EditUserDialogController);

  /** @ngInject */
  function EditUserDialogController($uibModalInstance,  _, $log, toastr, APIHandling, data) {
      var vm = this;
      vm.user = {};

      vm.validNama = /^[A-Za-z0-9\-\.\_]+$/;

      if (_.isUndefined(data)) {
        vm.template = {
          nama: null,
          template: null,
          new: true
        };
      } else {
        vm.template = _.cloneDeep(data);
        vm.template.new = false;
      }

      vm.finish = function () {

        APIHandling.post('sms-template/save', vm.template).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil simpan data template', 'Berhasil simpan');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal simpan data template', 'Gagal simpan');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('EditContactDialogController', EditContactDialogController);

  /** @ngInject */
  function EditContactDialogController($uibModalInstance,  _, $log, toastr, CONTACTHandling, LOCATIONHandling, data, $q) {
      var vm = this;
      vm.contact = {};
      vm.alamat = {
        source: {
          provinsi: LOCATIONHandling.provinsiRO,
          kabupaten: [],
          kecamatan: []
        },
        provinsi: null,
        kabupaten: null,
        kecamatan: null,

        validasi: {
          nomor: /^\d+$/
        }
      };

      vm.changeProvinsi =  function (prov_id) {

        $log.info('Ini prov jalan');

        if (prov_id) {
          vm.alamat.kabupaten = null;
          vm.alamat.kecamatan = null;
          vm.alamat.source.kecamatan = [];
          LOCATIONHandling.getKabupaten(prov_id).then(function (response) {
            vm.alamat.source.kabupaten = response.data.results;
          });
        }
      };

      vm.changeKabupaten = function (kab_id) {

        $log.info('Ini kab jalan');

        if (kab_id) {
          vm.alamat.kecamatan = null;
          LOCATIONHandling.getKecamatan(kab_id).then(function (response) {
            vm.alamat.source.kecamatan = response.data.results;
          });
        }
      };

      if (_.isUndefined(data)) {
        /** Jika data baru maka init kosong */
        vm.contact = {
          id: null,
          nama: null,
          email: null,
          hp: null,
          telp: null,
          alamat: null,
          prov: null,
          prov_id: 0,
          kab: null,
          kab_id: 0,
          kec: null,
          kec_id: 0,
          kode_pos: null,
          kelamin: 'P',
          extra: {
            keterangan: null
          }
        };
      } else {
        /** Jika data lama, maka init dari data yang sudah ada */
        vm.contact = _.cloneDeep(data);

        if ((vm.contact.prov_id !== 0) && (vm.contact.kab_id !== 0) && (vm.contact.kec_id !== 0))  {
          vm.alamat.provinsi = _.find(vm.alamat.source.provinsi, function (n) { return n.id === vm.contact.prov_id.toString(); } );

          $q.all([LOCATIONHandling.getKabupaten(vm.contact.prov_id), LOCATIONHandling.getKecamatan(vm.contact.kab_id)]).then (function (response) {
            vm.alamat.source.kabupaten = response[0].data.results;
            vm.alamat.source.kecamatan = response[1].data.results;

            vm.alamat.kabupaten = _.find(vm.alamat.source.kabupaten, function (n) { return (n.city_id * 1) === (vm.contact.kab_id * 1);});
            vm.alamat.kecamatan = _.find(vm.alamat.source.kecamatan, function (n) { return (n.subdistrict_id * 1) === (vm.contact.kec_id * 1);});
          });
        }

        vm.contact.extra = angular.fromJson(vm.contact.extra);

      }

      vm.save = function () {

        if (vm.alamat.provinsi) {
          vm.contact.prov = vm.alamat.provinsi.text;
          vm.contact.prov_id = vm.alamat.provinsi.id;
        }

        if (vm.alamat.kabupaten) {
          vm.contact.kab = vm.alamat.kabupaten.type + ' ' + vm.alamat.kabupaten.city_name;
          vm.contact.kab_id = vm.alamat.kabupaten.city_id;
        }

        if (vm.alamat.kecamatan) {
          vm.contact.kec = vm.alamat.kecamatan.subdistrict_name;
          vm.contact.kec_id = vm.alamat.kecamatan.subdistrict_id;
        }

        vm.contact.email = vm.contact.email || '';
        vm.contact.hp = vm.contact.hp || '';
        vm.contact.telp = vm.contact.telp || '';
        vm.contact.alamat = vm.contact.alamat || '';
        vm.contact.kode_pos = vm.contact.kode_pos || '';

        CONTACTHandling.save(vm.contact).then( function () {
          toastr.success('Berhasil simpan data kontak', 'Berhasil simpan');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal simpan data kontak', 'Gagal simpan');
          $uibModalInstance.dismiss('batal');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('DetailCustomerDialogController', DetailCustomerDialogController);

  /** @ngInject */
  function DetailCustomerDialogController($uibModalInstance, CONTACTHandling, data, toastr, $log) {
      var vm = this;
      vm.cust_id = data;
      vm.noConsumen = false;

      vm.initView = function () {

        CONTACTHandling.getCustomer(vm.cust_id).then( function (response) {
          vm.pelanggan = response.data;

          if (response.data.extra) {
            vm.pelanggan.extra = angular.fromJson(response.data.extra);
          } else {
            vm.pelanggan.extra = {
              keterangan: null
            };
          }

          $log.debug(vm.pelanggan);
        }, function (error) {
          $log.error(error);

          if (error.status === 404) {
            // toastr.error('Data pelanggan tidak ada atau sudah dihapus', 'Gagal');
            vm.noConsumen = true;
          } else {
            toastr.error('Terjadi kesalahan saat mengambil data pelanggan', 'Gagal');
          }
        });
      };

      vm.batal = function () {
        $uibModalInstance.dismiss('batal');
      };

      vm.initView();

  }

})();

 (function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('DeleteUserDialogController', DeleteUserDialogController);

  /** @ngInject */
  function DeleteUserDialogController($uibModalInstance,  _, $log, APIHandling, toastr, data) {
      var vm = this;
      vm.user = data;

      vm.finish = function () {

        APIHandling.post('user/delete', {id: vm.user.id}).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil menghapus pengguna', 'Sukses hapus');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal menghapus pengguna', 'Gagal hapus');
        }).finally(function () {
          $uibModalInstance.close('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('DeleteTemplateDialogController', DeleteTemplateDialogController);

  /** @ngInject */
  function DeleteTemplateDialogController($uibModalInstance,  _, $log, APIHandling, toastr, data) {
      var vm = this;
      vm.template = data;

      vm.finish = function () {

        APIHandling.post('sms-template/delete', {list_id: [vm.template.id]}).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil menghapus template', 'Sukses hapus');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal menghapus template', 'Gagal hapus');
          $uibModalInstance.dismiss('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('DeleteContactDialogController', DeleteContactDialogController);

  /** @ngInject */
  function DeleteContactDialogController($uibModalInstance,  $log, CONTACTHandling, toastr, data) {
      var vm = this;
      vm.contact = data;

      vm.finish = function () {

        CONTACTHandling.delete([vm.contact.id]).then( function () {
          toastr.success('Berhasil menghapus kontak', 'Sukses hapus');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal menghapus kontak', 'Gagal hapus');
          $uibModalInstance.dismiss('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

'use strict';
angular.module('CRMClient')
.filter('udate', function ($filter) {
  return function (input, format) {
    var date = new Date(input);

    return $filter('date')(date, format);
  };
});

(function () {
  'use strict';

  angular
    .module('CRMClient')
    .filter('fm-detail', fmdetail);

  function fmdetail(_) {
    return filterdetail;

    function filterdetail(detail) {

      var data = _.each(detail, function (n) {
        n.detail = angular.fromJson(n.detail);
        return n;
      });

      return data;
    }
  }
})();


/*eslint angular/no-private-call: [2,{"allow":["$$rawModelValue"]}]*/

/*
 * ng-locale-number
 * based on ng-currency
 * http://alaguirre.com/
 * Version: 0.9.6 - 2016-04-04
 * License: MIT
 */

angular.module('ng-locale-number', [])
    .directive('ngLocaleNumber', ngLocaleNumber);

    function ngLocaleNumber ($filter, $locale) {
        return {
            require: 'ngModel',
            scope: {
                min: '=?min',
                max: '=?max',
                ngRequired: '=?ngRequired',
                fraction: '=?fraction'
            },
            link: function (scope, element, attrs, ngModel) {

                if (attrs.ngLocaleNumber === 'false') return;

                scope.fraction = (typeof scope.fraction !== 'undefined')?scope.fraction:2;

                function decimalRex(dChar) {
                    return RegExp("\\d|\\-|\\" + dChar, 'g');
                }

                function clearRex(dChar) {
                    return RegExp("\\-{0,1}((\\" + dChar + ")|([0-9]{1,}\\" + dChar + "?))&?[0-9]{0," + scope.fraction + "}", 'g');
                }

                function clearValue(value) {
                    value = String(value);
                    var dSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
                    var cleared = null;

                    if(value.indexOf($locale.NUMBER_FORMATS.DECIMAL_SEP) == -1 &&
                       value.indexOf('.') != -1 &&
                       scope.fraction)
                    {
                        dSeparator = '.';
                    }

                    // Replace negative pattern to minus sign (-)
                    var neg_dummy = $filter('number')("-1",  scope.fraction);
                    var neg_regexp = RegExp("[0-9."+$locale.NUMBER_FORMATS.DECIMAL_SEP+$locale.NUMBER_FORMATS.GROUP_SEP+"]+");
                    var neg_dummy_txt = neg_dummy.replace(neg_regexp.exec(neg_dummy), "");
                    var value_dummy_txt = value.replace(neg_regexp.exec(value), "");

                    // If is negative, just remove the negative sign :-P
                    if(neg_dummy_txt == value_dummy_txt) {
                        value = '' + neg_regexp.exec(value);
                    }

                    if(RegExp("^-[\\s]*$", 'g').test(value)) {
                        value = "-0";
                    }

                    if(decimalRex(dSeparator).test(value))
                    {
                        cleared = value.match(decimalRex(dSeparator))
                            .join("").match(clearRex(dSeparator));
                        cleared = cleared ? cleared[0].replace(dSeparator, ".") : null;
                    }

                    return cleared;
                }

                function reformatViewValue(){
                    var formatters = ngModel.$formatters,
                        idx = formatters.length;

                    var viewValue = ngModel.$$rawModelValue;
                    while (idx--) {
                      viewValue = formatters[idx](viewValue);
                    }

                    ngModel.$setViewValue(viewValue);
                    ngModel.$render();
                }

                ngModel.$parsers.push(function (viewValue) {
                    var cVal = clearValue(viewValue);
                    //return parseFloat(cVal);
                    // Check for fast digitation (-. or .)
                    if(cVal == "." || cVal == "-.")
                    {
                        cVal = ".0";
                    }
                    return parseFloat(cVal);
                });

                element.on("blur", function () {
                    ngModel.$commitViewValue();
                    reformatViewValue();
                });

                ngModel.$formatters.unshift(function (value) {
                    return $filter('number')(value,  scope.fraction);
                });

                ngModel.$validators.min = function(cVal) {
                    if (!scope.ngRequired && isNaN(cVal)) {
                        return true;
                    }
                    if(typeof scope.min  !== 'undefined') {
                        return cVal >= parseFloat(scope.min);
                    }
                    return true;
                };

                scope.$watch('min', function () {
                    ngModel.$validate();
                });

                ngModel.$validators.max = function(cVal) {
                    if (!scope.ngRequired && isNaN(cVal)) {
                        return true;
                    }
                    if(typeof scope.max  !== 'undefined') {
                        return cVal <= parseFloat(scope.max);
                    }
                    return true;
                };

                scope.$watch('max', function () {
                    ngModel.$validate();
                });


                ngModel.$validators.fraction = function(cVal) {
                    if (!!cVal && isNaN(cVal)) {
                        return false;
                    }

                    return true;
                };

                element.on('focus',function(){
                    var viewValue = ngModel.$$rawModelValue;

                    if(isNaN(viewValue) || viewValue === '' || viewValue == null)
                    {
                        viewValue = '';
                    }
                    else
                    {
                        viewValue = parseFloat(viewValue).toFixed(scope.fraction);
                    }
                    ngModel.$setViewValue(viewValue);
                    ngModel.$render();
                });
            }
        };
    }

//
// angular-file-model
// ==================
//
// Directive that makes the inputs with type `file` to be
// available in the `$scope` and be assigned to a model.
//
(function () {
  'use strict';

  angular.module('file-model', [])

  .directive('fileModel', fileModel);

    function fileModel ($parse) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var model = $parse(attrs.fileModel);
          var modelSetter = model.assign;

          element.bind('change', function(){
            scope.$apply(function(){
              if (attrs.multiple) {
                modelSetter(scope, element[0].files);
              }
              else {
                modelSetter(scope, element[0].files[0]);
              }
            });
          });
        }
      };
    }


})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('MainDashboardController', MainDashboardController);

  /** @ngInject */
  function MainDashboardController($log) {
    $log.log('Dashboard');
  }
})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('MainContactController', MainContactController);

  /** @ngInject */
  function MainContactController($scope, $state) {

    var vm = this;

    /*
      Controller ini hanya dieksekusi sekali. Jika terjadi perubahan state di substate,
      maka isi Controller tidak akan dieksekusi lagi. Oleh karena itu, untuk merubah title
      perlu melakukan watch terhadap $state
    */
    $scope.$watch(function () {
      vm.state = $state.current.name;
      return $state.current.title;
    }, function (newVal) {
      vm.title = newVal;
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('MainAdministrasiController', MainAdministrasiController);

  /** @ngInject */
  function MainAdministrasiController($scope, $state) {

    var vm = this;

    /*
      Controller ini hanya dieksekusi sekali. Jika terjadi perubahan state di substate,
      maka isi Controller tidak akan dieksekusi lagi. Oleh karena itu, untuk merubah title
      perlu melakukan watch terhadap $state
    */
    $scope.$watch(function () {
      vm.state = $state.current.name;
      return $state.current.title;
    }, function (newVal) {
      vm.title = newVal;
    });

    // vm.resetData = function () {
    //   $scope.main.message = 'Reset data di aplikasi. Harap tunggu ...';
    //   angular.element('.loading-animation').show();
    //
    //
    //   APIHandling.get('user/reset').then(function () {
    //     toastr.success('Berhasil reset data aplikasi', 'Reset berhasil');
    //   }, function (error) {
    //     $log.debug(error);
    //     toastr.error('Gagal reset data aplikasi', 'Reset gagal');
    //   }).finally(function () {
    //     angular.element('.loading-animation').hide();
    //   });
    // }


  }
})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($state, store) {
    var vm = this;

    vm.navCollapsed = false;
    vm.message = '';

    vm.menuItem = [
        {
            text        : 'Kontak',
            sref        : 'main.contact.list',
            icon        : 'fa-users'
        },
        {
            text        : 'Setting',
            sref        : 'main.administrasi.users',
            icon        : 'fa-gear'
        },
        {
            text        :  '( ' + store.get('info').uname + ' ) ' +  'Logout',
            sref        : 'login',
            icon        : 'fa-sign-out'
        }
    ];

    vm.isActive = function (state) {
        var origin = state.split('.');
        var current = $state.current.name.split('.');

        if ((origin[0] === current[0]) && (origin[1] === current[1])) {
          return true;
        } else {
          return false;
        }

    };
  }
})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($log, APIHandling, $state, toastr, VERSION, BUILD) {
    var vm = this;

    vm.info = {
      server: null,
      client: {
        version: VERSION,
        build: BUILD
      }
    };

    vm.doLogin = function () {
      APIHandling.login(vm.user.uname, vm.user.password).then(function (response) {
        if (response.status === 200) {
          APIHandling.saveLoginState(response.data);
          $state.go('main.contact.list');
        }
      }, function (error) {
        $log.error(error);
        var msg = '';

        if (error.status === 503) {
          msg = 'Server sedang sibuk. Coba beberapa saat lagi';
        } else if (error.status === 401){
          msg = 'Username atau password salah';
        } else {
          msg = 'Terjadi masalah di server';
        }

        toastr.error(msg, 'Gagal login');
      });
    };

    APIHandling.cleanLoginState();
    APIHandling.getInfoServer().then(function (response) {
      vm.info.server = response.data;
      $log.info(vm.info);
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        abstrac: true,
        onEnter: function(){
            angular.element('.loader-container').hide();
        }
      })

      .state('main.contact', {
        url: '/contact',
        templateUrl: 'app/main/main.contact/main.contact.html',
        controller: 'MainContactController',
        controllerAs: 'vm',
        abstrac: true
      })
      .state('main.contact.list', {
        url: '/list',
        templateUrl: 'app/main/main.contact/main.contact.list/main.contact.list.html',
        controller: 'MainContactListController',
        controllerAs: 'vm',
        title: 'Daftar Kontak',
        onEnter: function($rootScope){
            $rootScope.title = 'Daftar Kontak | Simple CRM';
        }
      })
      .state('main.administrasi', {
        url: '/administrasi',
        templateUrl: 'app/main/main.administrasi/main.administrasi.html',
        controller: 'MainAdministrasiController',
        controllerAs: 'vm',
        abstrac: true,
        onEnter: function(store, $state) {
            var user = store.get('info');

            if (user.group !== 'admin') {
              $state.go('main.contact.list');
            }
        }
      })
      .state('main.administrasi.users', {
        url: '/users',
        templateUrl: 'app/main/main.administrasi/main.administrasi.users/main.administrasi.users.html',
        controller: 'MainAdministrasiUsersController',
        controllerAs: 'vm',
        title: 'Atur Pengguna',
        onEnter: function($rootScope){
            $rootScope.title = 'Atur Pengguna | Simple CRM';
        }
      })
      .state('main.administrasi.sms', {
        url: '/sms',
        templateUrl: 'app/main/main.administrasi/main.administrasi.sms/main.administrasi.sms.html',
        controller: 'MainAdministrasiSMSController',
        controllerAs: 'vm',
        title: 'Atur Template SMS',
        onEnter: function($rootScope){
            $rootScope.title = 'Atur Template SMS | Simple CRM';
        }
      })
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        onEnter: function($rootScope){
            angular.element('.loader-container').hide();
            $rootScope.title = 'Login | Simple CRM';
        }
      });

    $urlRouterProvider.otherwise('/login');
  }

})();

/* global _:false, moment:false, saveAs:false, Papa:false, pdfMake: false */
(function() {
  'use strict';

  angular
    .module('CRMClient')
    .constant('_', _)
    .constant('moment', moment)
    .constant('saveAs', saveAs)
    .constant('Papa', Papa)
    .constant('pdfMake', pdfMake)
    .constant('BASEURL', 'https://crm-6r0i4v4se1.ethica-collection.com/api/public/')
    .constant('TIMEOUT', 300000)
    .constant('VERSION', '0.2')
    .constant('BUILD', '20240530')
    .constant('APIDOMAIN', 'crm-6r0i4v4se1.ethica-collection.com');

})();

(function() {
  'use strict';

  angular
    .module('CRMClient')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider, $httpProvider, toastrConfig, jwtOptionsProvider, $qProvider, APIDOMAIN) {
    // Enable log
    $logProvider.debugEnabled(true);

    /* Hilangkan # di akhir url */
    $locationProvider.html5Mode(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 8000;
    toastrConfig.extendedTimeOut = 2500;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;

    // jwtInterceptorProvider.tokenGetter = ['store', function(store) {
    //     return store.get('token');
    // }];

    jwtOptionsProvider.config({
      tokenGetter: ['store', function (store) {
        return store.get('token');
      }],
      whiteListedDomains: [APIDOMAIN]
    });

    $httpProvider.interceptors.push('jwtInterceptor');
    $httpProvider.interceptors.push('AuthInterceptor');

    /** Temporary measure to remove annoying error warning */
    $qProvider.errorOnUnhandledRejections(false);
  }

})();

angular.module("CRMClient").run(["$templateCache", function($templateCache) {$templateCache.put("app/login/login.html","<div class=\"container-fluid login-container\"><div class=row><div class=\"col-sm-12 text-center\"><h1 class=title>SIMPLE</h1><h2 class=title>Customer Relationship Management</h2></div></div><div class=\"row login-box\" style=margin-top:15vh><div class=col-sm-8><!--<img src=\"assets/images/logo.png\" alt=\"Logo Simple POS\" width=\"20%\" />--><h1>Ethica Collection</h1><h3>Agen Busana Muslim Ethica</h3><h4>Jalan Masjid Raya Al Hikmah RT 29/RW 05 Karang Rejo</h4><h4>Ngasem Kabupaten Kediri</h4></div><div class=\"col-sm-4 text-center\"><form class=form name=loginForm style=\"margin-top: 2em\"><div class=form-group><input type=text class=\"form-control input-lg text-center\" placeholder=\"User Name\" autofocus required ng-model=vm.user.uname></div><div class=form-group><input type=password class=\"form-control input-lg text-center\" placeholder=Password required ng-model=vm.user.password></div><div class=form-group><input type=submit class=\"btn btn-primary btn-lg btn-block\" value=\"L O G I N\" ng-disabled=loginForm.$invalid ng-click=vm.doLogin()></div></form></div></div><div class=row><div class=\"col-sm-12 text-center\"><h4><small class=versi>Versi {{vm.info.client.version}}<br>Client build: {{vm.info.client.build}}<br>Server build: {{vm.info.server.versi}}</small></h4></div></div></div>");
$templateCache.put("app/main/main.html","<nav class=\"navbar navbar-static-top navbar-custom\"><div class=container-fluid><!-- Brand and toggle get grouped for better mobile display --><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#bs-example-navbar-collapse-1 aria-expanded=false ng-init=\"main.navCollapsed = true\" ng-click=\"main.navCollapsed = !main.navCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href=#>Simple CRM</a></div><!-- Collect the nav links, forms, and other content for toggling --><div uib-collapse=main.navCollapsed class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-1><ul class=\"nav navbar-nav navbar-right\"><li ng-repeat=\"item in main.menuItem\"><a ui-sref={{::item.sref}} ng-class=\"{active: main.isActive(item.sref)}\"><i class=\"fa {{::item.icon}}\"></i> {{::item.text}}</a></li></ul></div><!-- /.navbar-collapse --></div><!-- /.container-fluid --></nav><div class=container-fluid style=\"padding-bottom: 2em\"><div ui-view></div></div><div class=loading-animation><div class=cssload-thecube><div class=\"cssload-cube cssload-c1\"></div><div class=\"cssload-cube cssload-c2\"></div><div class=\"cssload-cube cssload-c4\"></div><div class=\"cssload-cube cssload-c3\"></div></div><h2 class=\"text-center loading-information\">{{main.message}}</h2></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.html","<div class=row><div class=\"col-sm-12 text-center\"><h3 class=page-title>{{vm.title}}</h3></div></div><hr><div class=row><div class=col-sm-3><!--<div class=\"row\">\n            <div class=\"col-sm-12\">\n                <a class=\"btn btn-block btn-left \" uib-tooltip=\"Sinkronisasi data dar website, server aplikasi, dan lokal\" ui-sref=\"main.administrasi.sinkronisasi\" ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.sinkronisasi\', \'btn-default\': vm.state !==\'main.administrasi.sinkronisasi\'}\"  >\n                  <i class=\"fa fa-fw fa-refresh\"></i>  Sinkronisasi Data</a>\n            </div>\n        </div>--><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Atur pengguna aplikasi\" ui-sref=main.administrasi.users ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.users\', \'btn-default\': vm.state !==\'main.administrasi.users\'}\"><i class=\"fa fa-fw fa-users\"></i> Atur Pengguna</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Administrasi produk\" ui-sref=main.administrasi.sms ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.sms\', \'btn-default\': vm.state !==\'main.administrasi.sms\'}\"><i class=\"fa fa-fw fa-envelope-o\"></i> Template SMS</a></div></div><!-- <div class=\"row\" style=\"margin-top:1em;\">\n            <div class=\"col-sm-12\">\n                <a class=\"btn btn-block btn-danger btn-left \" uib-tooltip=\"Reset data di aplikasi\" ng-click=\"vm.resetData()\" ><i class=\"fa fa-fw fa-recycle\"></i>  Reset Data</a>\n            </div>\n        </div> --></div><div class=col-sm-9><div ui-view></div></div></div>");
$templateCache.put("app/main/main.contact/main.contact.html","<div class=row><div class=\"col-sm-12 text-center\"><h3 class=page-title>{{vm.title}}</h3></div></div><hr><div class=row><div class=col-sm-3><div class=row><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Daftar Kontak\" ui-sref=main.contact.list ng-class=\"{\'btn-info\': vm.state ===\'main.contact.list\', \'btn-default\': vm.state !==\'main.contact.list\'}\"><i class=\"fa fa-fw fa-users\"></i> Daftar Kontak</a></div></div></div><div class=col-sm-9><div ui-view></div></div></div>");
$templateCache.put("app/main/main.dashboard/main.dashboard.html","<div class=row><div class=col-sm-4><a ui-sref=main.pos class=\"btn btn-success btn-block btn-lg btn-elg\"><i class=\"fa fa-shopping-cart fa-4x fa-fw\"></i><br>Kasir</a></div><div class=col-sm-4><a ui-sref=main.stock class=\"btn btn-danger btn-block btn-lg btn-elg\"><i class=\"fa fa-cubes fa-4x fa-fw\"></i><br>Data Stok</a></div><div class=col-sm-4><a ui-sref=main.stock class=\"btn btn-warning btn-block btn-lg btn-elg\"><i class=\"fa fa-gear fa-4x fa-fw\"></i><br>Setting</a></div></div>");
$templateCache.put("app/components/modals/DeleteContact/DeleteContactDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Hapus Kontak</h4></div><div class=modal-body><h4>Anda yakin hendak menghapus kontak berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row>Nama</th><td>{{vm.contact.nama}}</td></tr><tr><th scope=row>Email</th><td>{{vm.contact.email}}</td></tr><tr><th scope=row>No HP</th><td>{{vm.contact.hp}}</td></tr><tr><th scope=row>Alamat</th><td>{{vm.contact.alamat}} {{vm.contact.kec}} {{vm.contact.kab}} {{vm.contact.prov}} {{vm.contact.kode_pos}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/DeleteTemplate/DeleteTemplateDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Hapus Template</h4></div><div class=modal-body><h4>Anda yakin hendak menghapus template berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row>Nama</th><td>{{vm.template.nama}}</td></tr><tr><th scope=row>Isi Template</th><td>{{vm.template.template}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/DeleteUser/DeleteUserDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Hapus Pengguna</h4></div><div class=modal-body><h4>Anda yakin hendak menghapus pengguna berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row>Username</th><td>{{vm.user.uname}}</td></tr><tr><th scope=row>Nama</th><td>{{vm.user.detail.name}}</td></tr><tr><th scope=row>Group</th><td>{{vm.user.group | uppercase}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish() ng-disabled=userForm.$invalid><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/DetailCustomer/DetailCustomerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user\"></i> Detail Pelanggan #{{::vm.cust_id}} {{::vm.pelanggan.nama}}</h4></div><div class=modal-body><table class=\"table table-condensed\" ng-if=!vm.noConsumen><tr><th scope=row class=col-sm-3>Nama</th><td>: {{vm.pelanggan.nama}}</td></tr><tr><th scope=row class=col-sm-3>Email</th><td>: <a ng-href=mailto:{{vm.pelanggan.email}}>{{vm.pelanggan.email}}</a></td></tr><tr><th scope=row class=col-sm-3>No HP</th><td>: {{vm.pelanggan.hp}}</td></tr><tr><th scope=row class=col-sm-3>No Telepon</th><td>: {{vm.pelanggan.telp}}</td></tr><tr><th scope=row class=col-sm-3>Alamat</th><td>: {{vm.pelanggan.alamat}} {{vm.pelanggan.kec}} {{vm.pelanggan.kab}} {{vm.pelanggan.prov}} {{vm.pelanggan.kode_pos}}</td></tr><tr><th scope=row class=col-sm-3>Keterangan</th><td>: {{vm.pelanggan.extra.keterangan}}</td></tr></table><div class=\"alert alert-danger\" ng-if=vm.noConsumen>Data pelanggan tidak ada atau sudah dihapus</div></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-check-circle\"></i> Selesai</button></div><div class=col-sm-4><button class=\"btn btn-warning btn-block\" type=button ng-click=vm.cetakAlamat() ng-if=vm.pelanggan.alamat><i class=\"fa fa-print\"></i> Cetak Alamat</button></div></div></div></div>");
$templateCache.put("app/components/modals/EditContact/EditContactDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user\"></i> Kontak</h4></div><div class=modal-body><form action=\"\" class=form name=contactForm><div class=row><div class=\"form-group col-sm-2\"><select name=\"\" class=form-control ng-model=vm.contact.kelamin><option value=P>Ibu</option><option value=L>Bpk</option></select></div><div class=\"form-group col-sm-6\"><input type=text class=form-control placeholder=\"Nama Lengkap\" ng-model=vm.contact.nama required></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"Kode Kontak\" ng-model=vm.contact.cust_code disabled></div></div><div class=row><div class=\"form-group col-sm-4\"><input type=email class=form-control placeholder=Email ng-model=vm.contact.email ng-required=!vm.contact.hp></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"Nomor Hand Phone\" ng-model=vm.contact.hp ng-required=!vm.contact.email ng-pattern=vm.alamat.validasi.nomor></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"Nomor Telepon\" ng-model=vm.contact.telp ng-pattern=vm.alamat.validasi.nomor></div></div><hr><div class=row><div class=\"form-group col-sm-8\"><input type=text class=form-control placeholder=Alamat ng-model=vm.contact.alamat ng-required=vm.alamat.provinsi></div><div class=\"form-group col-sm-4\"><ui-select ng-model=vm.alamat.provinsi ng-change=vm.changeProvinsi(vm.alamat.provinsi.id) ng-required=vm.contact.alamat><ui-select-match placeholder=Provinsi><span>{{$select.selected.text}}</span></ui-select-match><ui-select-choices repeat=\"prov in (vm.alamat.source.provinsi | filter: $select.search)\"><span><strong>{{prov.text}}</strong></span></ui-select-choices></ui-select></div></div><div class=row><div class=\"form-group col-sm-4\"><ui-select ng-model=vm.alamat.kabupaten ng-change=vm.changeKabupaten(vm.alamat.kabupaten.city_id) ng-required=vm.contact.alamat ng-disabled=\"vm.alamat.source.kabupaten.length < 1\"><ui-select-match placeholder=\"Kabupaten / Kota\"><span>{{$select.selected.type}} {{$select.selected.city_name}}</span></ui-select-match><ui-select-choices repeat=\"kab in (vm.alamat.source.kabupaten | filter: $select.search)\"><span><strong>{{kab.type}} {{kab.city_name}}</strong></span></ui-select-choices></ui-select></div><div class=\"form-group col-sm-4\"><ui-select ng-model=vm.alamat.kecamatan ng-required=vm.contact.alamat ng-disabled=\"vm.alamat.source.kecamatan.length < 1\"><ui-select-match placeholder=Kecamatan><span>{{$select.selected.subdistrict_name}}</span></ui-select-match><ui-select-choices repeat=\"kec in (vm.alamat.source.kecamatan | filter: $select.search)\"><span><strong>{{kec.subdistrict_name}}</strong></span></ui-select-choices></ui-select></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"Kode Pos\" ng-model=vm.contact.kode_pos maxlength=5 ng-pattern=vm.alamat.validasi.nomor></div></div><hr><div class=row><div class=\"form-group col-sm-12\"><ui-select ng-model=vm.contact.tag ng-disabled=true><ui-select-match placeholder=Tags><span>{{$select.selected.text}}</span></ui-select-match><ui-select-choices repeat=\"prov in (vm.alamat.source.provinsi | filter: $select.search)\"><span><strong>{{prov.text}}</strong></span></ui-select-choices></ui-select></div></div><div class=row><div class=\"form-group col-sm-12\"><textarea class=form-control placeholder=Keterangan... rows=3 ng-model=vm.contact.extra.keterangan></textarea></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.save() ng-disabled=contactForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/EditSMS/EditSMSDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-envelope-o\"></i> Template</h4></div><div class=modal-body><form action=\"\" class=form-horizontal name=templateForm><div class=form-group><label class=\"col-sm-4 control-label\" style=\"text-align: left\">Nama Template</label><div class=col-sm-8><input type=text class=form-control placeholder=\"Masukkan nama template\" ng-model=vm.template.nama ng-disabled=!vm.template.new required ng-pattern=vm.validNama></div></div><div class=form-group><label class=\"col-sm-4 control-label\" style=\"text-align: left\">Isi Template</label><div class=col-sm-8><textarea type=text class=form-control placeholder=\"Masukkan isi template\" rows=4 ng-model=vm.template.template maxlength=120 required></textarea></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=templateForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/EditUser/EditUserDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user\"></i> Pengguna</h4></div><div class=modal-body><form action=\"\" class=form-horizontal name=userForm><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Username</label><div class=col-sm-6><input type=text class=form-control placeholder=\"Masukkan username\" ng-model=vm.user.uname required ng-disabled=!vm.user.new></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Nama</label><div class=col-sm-6><input type=text class=form-control placeholder=\"Masukkan nama\" ng-model=vm.user.detail.name required></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Grup</label><div class=col-sm-6><select class=form-control ng-model=vm.user.group required><option value=usr>User</option><option value=admin>Admin</option></select></div></div><hr><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Password</label><div class=col-sm-6><input type=password class=form-control placeholder=\"Masukkan password\" ng-model=vm.user.password ng-required=vm.user.new></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Konfirmasi Password</label><div class=col-sm-6><input type=password class=form-control placeholder=\"Masukkan ulang password\" ng-model=vm.user.confirm_password ng-required=vm.user.new></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=userForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/ImportContact/ImportContactDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-cloud-upload\"></i> Import Kontak</h4></div><div class=modal-body><form action=\"\" class=form><div class=row><div class=\"col-sm-12 form-group\"><label for=\"\">Pilih file csv yang akan diimport</label><input type=file class=\"form-control input-file\" file-model=vm.inputFile></div></div><!--<div class=\"row\" style=\"margin-top: 1em;\">\n            <div class=\"col-sm-12 form-group\">\n              <label for=\"\">Pilih fields yang akan disimpan</label>\n              <ui-select multiple ng-model=\"vm.fields.result\" >\n                  <ui-select-match placeholder=\"Pilih fields yang disimpan\" >\n                      <span>{{$item.nama}}</span>\n                  </ui-select-match>\n                  <ui-select-choices repeat=\"item in (vm.fields.source | filter: $select.search) track by item.id\"  >\n                      <span><strong>{{item.nama}}</strong></span>\n                  </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>--></form></div><div class=modal-footer><div class=row><div class=\"col-sm-6 col-sm-offset-2 pull-right\"><button class=\"btn btn-warning btn-block\" type=button ng-click=vm.importTheFile() ng-disabled=vm.inProcess><i class=\"fa fa-cloud-upload\"></i> Proses Import</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/PrintContact/PrintContactDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-print\"></i> Cetak Alamat</h4></div><div class=modal-body><div class=well><h4>{{vm.contact.nama}}</h4><h5>{{vm.contact.alamat}} {{vm.contact.kec}}</h5><h5><strong>{{vm.contact.kab}} {{vm.contact.prov}}</strong></h5><h5>{{vm.contact.hp}}</h5><h5><a href=mailto:{{vm.contact.email}}>{{vm.contact.email}}</a></h5></div><hr><form action=\"\" class=form-horizontal name=printForm><div class=form-group><label class=\"col-sm-4 control-label\" style=\"text-align: left\">Pengirim</label><div class=col-sm-8><select name=\"\" class=form-control ng-model=vm.option.sender><option value=ethica>Ethica Collection</option><option value=zafrada>Zafrada</option><option value=dropship>Dropship</option></select></div></div><div class=form-group uib-collapse=\"vm.option.sender !== \'dropship\'\"><label for=\"\" class=\"col-sm-4 control-label\" style=\"text-align: left\">Pengirim Dropship</label><div class=col-sm-8><ui-select ng-model=vm.option.dropship.sender autofocus><ui-select-match placeholder=\"Nama Pengirim...\"><span>{{$select.selected.nama}}</span></ui-select-match><ui-select-choices repeat=\"contact in (vm.contactList) track by contact.id\" refresh=vm.getContact($select.search) refresh-delay=300 minimum-input-length=3><div ng-if=!contact.info><span><strong>{{contact.nama}}</strong></span><br><small ng-if=contact.email>Email : {{contact.email}}<br></small><small ng-if=contact.hp>HP : {{contact.hp}}</small></div><div ng-if=contact.info><strong ng-bind=contact.nama></strong><br><small><span ng-bind=contact.info></span></small></div></ui-select-choices></ui-select></div></div><div class=form-group ng-if=\"vm.option.dropship.sender.id == 0\"><label for=\"\" class=\"col-sm-4 control-label\" style=\"text-align: left\">Alamat Pengirim</label><div class=col-sm-8><input type=text ng-model=vm.option.dropship.sender.alamat_sender class=form-control></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=printForm.$invalid><i class=\"fa fa-print\"></i> Cetak</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.sms/main.administrasi.sms.html","<div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-block btn-default\" ng-click=vm.editTemplate()><i class=\"fa fa-envelope\"></i></button></div></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col>No</th><th scope=col>Nama</th><th scope=col>Template</th><th scope=col class=autofit></th></tr></thead><tbody><tr ng-repeat=\"template in vm.templateList track by template.id\"><td class=text-right>{{$index + 1}}</td><td><a href ng-click=vm.editTemplate(template)>{{template.nama}}</a></td><td>{{template.template}}</td><td class=autofit><button class=\"btn btn-xs btn-default\" ng-click=vm.deleteTemplate(template) ng-disabled=\"template.nama === \'info-resi\'\"><span class=text-danger><i class=\"fa fa-trash\"></i></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.users/main.administrasi.users.html","<div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-block btn-default\" ng-click=vm.userModal()><i class=\"fa fa-user-plus\"></i></button></div></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col>No</th><th scope=col>Username</th><th scope=col>Nama</th><th scope=col>Grup</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"user in vm.userList track by user.id\"><td class=\"text-right col-sm-1\">{{$index + 1}}</td><td class=col-sm-3><a href ng-click=vm.userModal(user)>{{user.uname}}</a></td><td class=col-sm-4>{{user.detail.name}}</td><td>{{user.group | uppercase}}</td><td class=autofit><button class=\"btn btn-xs btn-default\" ng-click=vm.deleteUser(user) ng-if=\"user.uname !== vm.currentUser.uname\"><span class=text-danger><i class=\"fa fa-trash\"></i></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.contact/main.contact.list/main.contact.list.html","<div class=row><form><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\" uib-tooltip=Filter><i class=\"fa fa-search\"></i></button></div><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.deleteSelectedContacts() type=button style=\"border-right: none\" uib-tooltip=\"Hapus kontak yg dipilih\"><i class=\"fa fa-trash\"></i></button></div><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.editContact() type=button uib-tooltip=\"Buat kontak baru\"><i class=\"fa fa-user-plus\"></i></button></div></div></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"Customer ID\" ng-model=vm.filter.by_cust_code></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"Nama atau email\" ng-model=vm.filter.search></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"No HP\" ng-model=vm.filter.by_hp></div></form></div><div class=row><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.importContact() type=button style=\"border-right: none\" uib-tooltip=\"Import kontak\"><i class=\"fa fa-cloud-upload\"></i></button></div><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.downloadContact() type=button uib-tooltip=\"Download kontak\"><i class=\"fa fa-cloud-download\"></i></button></div></div></div></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col><input type=checkbox ng-model=vm.check.mainItem ng-change=vm.check.checkAll() uib-tooltip=\"Pilih semua\"></th><th scope=col class=autofit>No</th><th scope=col class=autofit>ID</th><th scope=col>Nama</th><th scope=col>Kontak</th><th scope=col>Alamat</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"item in vm.contactList track by item.id\"><td class=autofit><input type=checkbox ng-model=vm.check.item[$index].status></td><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td class=col-sm-2>{{item.cust_code}}</td><td class=col-sm-2><a href ng-click=vm.editContact(item)>{{item.nama}}</a></td><td class=col-sm-2><a href=mailto:{{item.email}}>{{item.email}}</a> {{item.hp}}</td><td class=col-sm-4>{{item.alamat}} {{item.kec}} {{item.kab}} {{item.prov}}</td><td class=col-sm-1><button class=\"btn btn-default btn-xs\" uib-tooltip=\"Cetak Alamat\" ng-click=vm.printContact(item)><span class=text-info><i class=\"fa fa-print fa-fw\"></i></span></button> <button class=\"btn btn-default btn-xs\" uib-tooltip=\"Hapus kontak\" ng-click=vm.deleteContact(item)><span class=text-danger><i class=\"fa fa-trash fa-fw\"></i></span></button></td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=col-sm-6><button class=\"btn btn-default btn-block\" disabled>Menampilkan halaman : {{vm.filter.page}}</button></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");}]);